import React, { FC, memo, useEffect, useState } from 'react';
import moment, { Moment } from 'moment';
import { IEvents } from 'types';
import { timezone } from 'utils/helpers/momentTime';
import CustomButton from 'components/common/customButton/customButton';
import _ from 'lodash';
import { Scrollbars } from 'react-custom-scrollbars';
import TimeLine from 'components/common/calendar/timeLine';
import arrow from 'style/imgs/icons/arrow.svg';
import styles from 'components/common/calendar/index.module.scss';
import calendarIcon from 'style/imgs/icons/Calendar.svg';
import Event from './events';
import scheduleStyles from '../index.module.scss';

interface ISchedule {
  events: IEvents[];
  startDate: string;
}
const Schedule: FC<ISchedule> = ({ events, startDate }) => {
  const [week, setWeeks] = useState(0);
  const [days, setDays] = useState<Moment[][]>([]);
  const [timeLine, setTimeLine] = useState<string[]>([]);
  const [displayDate, setDisplayDate] = useState(
    moment(+startDate).format('dddd')
  );

  useEffect(() => {
    const day = moment(+startDate).subtract(1, 'day');
    const lastDay = moment(+startDate)
      .clone()
      .add(6, 'days');
    const calendar = [];

    while (day.isBefore(lastDay, 'day')) {
      calendar.push(
        Array(1)
          .fill(0)
          .map(() => day.add(1, 'day').clone())
      );
    }
    setWeeks(0);
    setDays(calendar);
  }, [startDate]);

  useEffect(() => {
    setDisplayDate(`${moment(days[week] && days[week][0]).format('dddd')}`);
  }, [days, week]);

  const renderBlocks = (
    event: IEvents,
    timeStamp: string,
    day: moment.Moment
  ) => {
    let render = null;
    const eventTime = moment(
      `${moment(event.startTimeStr, 'HH:mm').format('LT')} ${moment(day).format(
        'MMM, D'
      )}`
    );
    const position = moment(`${timeStamp} ${moment(day).format('MMM, D')}`);
    const diff = eventTime.diff(position, 'minutes');

    if (
      event.startTimeStr === moment(timeStamp, 'LT').format('HH:mm') ||
      (diff <= 14 && diff > 0)
    ) {
      if (
        day.format('YYYY-MM-DD') ===
        moment(event.startTime, 'YYYY-MM-DD HH:mm')
          .add(timezone, 'minutes')
          .format('YYYY-MM-DD')
      ) {
        render = <Event diff={diff} key={event.id} day={day} event={event} />;
      }
    }
    return render;
  };
  const handleNext = () => {
    if (week < days.length - 1) {
      setWeeks(week + 1);
    }
    if (days.length - 1 === week) {
      setWeeks(0);
    }
  };

  const handlePrev = () => {
    if (week >= 1) {
      setWeeks(week - 1);
    }
    if (week === 0) {
      setWeeks(6);
    }
  };

  return (
    <>
      <div className={scheduleStyles.scheduleHeader}>
        <span className="message-title">Schedule</span>
        <div
          className={`${styles.switchDaysButtons} ${scheduleStyles.calendarButton}`}
        >
          <button
            onClick={handlePrev}
            type="button"
            className={styles.buttonNext}
          >
            <img src={arrow} alt="prev" />
          </button>
          <CustomButton
            width={100}
            color="orange"
            text={displayDate}
            icon={calendarIcon}
            disableCalendar
          />
          <button
            onClick={handleNext}
            type="button"
            className={styles.buttonNext}
          >
            <img src={arrow} alt="next" />
          </button>
        </div>
      </div>
      <Scrollbars autoHeight autoHeightMax={420}>
        <div className={scheduleStyles.tableBlock}>
          <TimeLine cellSize="S" onChange={setTimeLine} timeLine={timeLine} />
          <div className={`${styles.days} ${scheduleStyles.days}`}>
            {!_.isEmpty(days) &&
              !_.isEmpty(days[week]) &&
              days[week].map((day: moment.Moment) => (
                <div
                  key={day.format('DD-MM-YYYY')}
                  style={{ width: '100%' }}
                  className={styles.day}
                >
                  {timeLine.map((timeStamp: string) => (
                    <div key={timeStamp} className={styles.timeLine}>
                      {events &&
                        events.map((e: IEvents) =>
                          renderBlocks(e, timeStamp, day)
                        )}
                    </div>
                  ))}
                </div>
              ))}
          </div>
        </div>
      </Scrollbars>
    </>
  );
};

export default memo(Schedule);
